/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import { useMemo } from "react";
import ProviderApp from "../../ProviderApp";
import UserNameTagComponentWithProvider, {
  UserNameTagComponentWithProviderProps,
} from "./UserNameTagComponentWithProvided";

function UserNameTagComponent(props: UserNameTagComponentWithProviderProps) {
  const provider = useMemo(
    () => (
      <ProviderApp>
        <UserNameTagComponentWithProvider {...props} />
      </ProviderApp>
    ),

    [props.id, props.email, props.userIdsForGroup, props.handleDeleteIconClicked], // Re-memoize when the 'id'/'email' prop changes
  );

  return provider;
}

export default UserNameTagComponent;
